module.exports = __webpack_public_path__ + "img/areas1.40f6d8f4.png";